export default "__VITE_ASSET__OIfyIiGW__"